<template>
  <v-form ref="form" style="height: 100%; justify-content: space-between; display: flex; flex-direction: column;">
    <div>
      <p class="step-sub-content text-center">
        +82 {{ this.$helper.formatPhoneNumber(userData.loginId) }} 번호로
        <br/>
        인증번호를 문자로 전송해 드렸습니다.
      </p>
      <!-- 인증번호 입력 폼 -->
      <SMSAuthDigitForm :userDigit="userDigit" @update:userDigit="val => userDigit = val" />

      <p v-if="!smsRetry.retry" class="step-sub-content text-center">
        <strong>{{ smsRetry.countdown }}초 후</strong> 재전송이 가능합니다.
      </p>
      <p v-else class="step-sub-content text-center" >
        인증번호를 못 받으셨나요?
        <br/>
        <u @click="onSmsAuthResend" style="cursor: pointer;">이곳</u>을 클릭하여 재시도 해주시기바랍니다.
      </p>
    </div>
    <div class="bottom-btn">
      <v-btn color="mainColorDark" x-large depressed block class="mb-3 btn-text-white"
        :disabled="userDigit.length !== 4 || !/^\d{4}$/.test(userDigit)"
        @click="$emit('validAuthCode', userDigit)"
      >
        인증확인
      </v-btn>
      <v-btn color="mainColorLight" x-large depressed block @click="$emit('clickBack')">이전단계</v-btn>
    </div>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import SMSAuthDigitForm from "./comp/SMSAuthDigitForm.vue";

export default {
  components: { SMSAuthDigitForm },
  props: {
    smsAuthStep: Number,
    userData: {
      type: Object,
    },
    smsRetry:  {
      type: Object,
    },
  },
  computed: {
    ...mapGetters(["isAuthorized"]),
  },
  methods: {
    onSmsAuthResend() {
      this.userDigit = ""; // 초기화
      this.$emit('startSmsAuthSend'); // 이벤트 발생
    }
  },
  data() {
    return {
      userDigit: ""
    };
  },
};
</script>
